/**
 * EduAnaliz giriş rolleri — TEK LİSTE.
 *
 * İki ayrı giriş ekranı var ve ikisi de kendi kopyasını taşıyordu:
 * açılış sayfasındaki form (`EduAnalizLanding.tsx`) ve ana uygulamadan
 * açılan kip (`EduAnalizLoginModal.tsx`). Veli rolü eklenirken biri
 * atlansaydı veli hangi ekrandan girdiğine göre ya girebilir ya
 * giremezdi — ve giremediğinde hata "şifre yanlış" gibi görünürdü.
 *
 * Sunucu tarafındaki karşılığı `EduAnalizUser.role` enum'u.
 */
export type EaRol = 'teacher' | 'guidance' | 'admin' | 'student' | 'parent';

export interface EaRolSecenegi {
    id: EaRol;
    label: string;
    /** Açılış sayfasındaki düğmelerde kullanılan simge. */
    icon: string;
}

export const EA_ROLLER: EaRolSecenegi[] = [
    { id: 'teacher',  label: 'Öğretmen',          icon: '📚' },
    { id: 'guidance', label: 'Rehberlik Servisi', icon: '👨‍🏫' },
    { id: 'admin',    label: 'Yönetici',          icon: '🛡️' },
    { id: 'student',  label: 'Öğrenci',           icon: '🎓' },
    { id: 'parent',   label: 'Veli',              icon: '👪' },
];
